export default "<app-header></app-header>\n<div class=\"container\">\n    <router-outlet></router-outlet>\n</div>";